export default __webpack_public_path__ + "static/Chaga-green-e4f6496797621996c9fa367d87eb8dc0.svg";